var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerServicesLogoFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7355 106C69.3059 99.1412 76.3145 90.5154 81.289 80.7037C87.7073 69.183 89.417 55.6044 86.0565 42.8392C81.3133 26.8836 65.176 17.2655 48.9755 20.7383C48.1809 20.7383 47.3334 20.7383 46.2739 21.0579C47.9642 13.4984 51.8336 6.60758 57.3982 1.24691C58.4054 0.506285 59.6567 0.182248 60.8944 0.34157C88.9982 1.65261 111.101 24.9631 111.058 53.2471C111.016 81.5311 88.8431 104.774 60.7355 106Z",
    fill: "#001B53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6994 86.035C60.0782 93.2444 56.5322 99.8624 51.4497 105.164C50.6447 105.812 49.6157 106.102 48.5966 105.968C21.7189 104.004 0.700113 81.6711 0.0170826 54.3502C-0.665948 27.0292 19.2099 3.64427 45.955 0.30188C44.7398 1.37354 43.8945 2.12371 43.102 2.92746C27.5189 17.2957 20.213 38.7168 23.7121 59.7792C24.971 68.0756 29.4475 75.5174 36.1454 80.4486C42.8433 85.3797 51.2068 87.3911 59.3747 86.035C60.1486 85.9804 60.9254 85.9804 61.6994 86.035Z",
    fill: "#001B53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2868 54.8829C43.2868 50.1701 43.2868 45.5092 43.2868 40.8482C43.2868 36.1873 45.0794 35.6694 48.5193 37.5856C56.2711 42.1947 64.0229 46.8557 71.6778 51.5684C74.8269 53.4846 74.8269 55.7115 71.6778 57.6276C63.8291 62.4957 55.9804 67.2603 48.0348 71.973C45.1763 73.682 43.1899 72.6462 43.1899 69.1764C43.1899 64.4119 43.1899 59.6474 43.1899 54.8829",
    fill: "#1C6ACF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerServicesLogoFavicon);
export default __webpack_public_path__ + "static/media/dealerServicesLogoFavicon.598a0fafbf509641af8a41c5027cb23f.svg";
export { ForwardRef as ReactComponent };